module.exports = __webpack_public_path__ + "img/home-line2-img3.507e6dea.png";